/* ============
 * Actions for the module
 * ============
 *
 * The actions that are available on the
 * module.
 */
import actionTypes from "@actionTypes";
import Http from "@api/http";

export function authCheck() {
  return {
    type: actionTypes.AUTH_CHECK,
  };
}

/* LOGIN */
export function login(payload) {
  return {
    type: actionTypes.DO_LOGIN,
    payload,
  };
}
export function loginSuccess(payload) {
  Http.defaults.headers.common.Authorization = `Bearer ${payload.data.access_token}`;
  return {
    type: actionTypes.DO_LOGIN_SUCCESS,
    payload,
  };
}
export function loginFailed(payload) {
  return {
    type: actionTypes.DO_LOGIN_FAILED,
    payload,
  };
}

export function logout(navigate) {
  return {
    type: actionTypes.DO_LOGOUT,
    payload: { navigate },
  };
}
export function logoutSuccess() {
  return {
    type: actionTypes.DO_LOGOUT_SUCCESS,
  };
}
export function logoutFailed(error) {
  return {
    type: actionTypes.DO_LOGOUT_FAILED,
    payload: error,
  };
}

export function registMember(payload) {
  return {
    type: actionTypes.DO_REGIST_MEMBER,
    payload,
  };
}

export function profileUpdate(payload) {
  return {
    type: actionTypes.DO_PROFILE_UPDATE,
    payload,
  };
}

export function getProfile(payload) {
  return {
    type: actionTypes.DO_GET_PROFILE,
    payload,
  };
}

export function oauthHappys(payload) {
  return {
    type: actionTypes.DO_OAUTH_HAPPYS,
    payload,
  };
}
